import { useTranslation } from 'react-i18next'

import { FC } from 'react'
import { ACheckboxV2 } from 'views/components/Analytics'

type Props = {
  value: string
  updateFilterState: (value: Record<string, boolean | undefined>) => void
}

export const CallsShipedDealFilter: FC<Props> = ({ value, updateFilterState }) => {
  const { t } = useTranslation('dashboard')

  return (
    <ACheckboxV2
      id="hasShippedDeal"
      onChange={(e) => updateFilterState({ has_shipped_deals_flag: e.target.checked ? true : undefined })}
      checked={value ? JSON.parse(value) : undefined}
      label={t('shippedDeals')}
    />
  )
}
